import React from "react";

// Import your images here (adjust paths based on your folder structure)
import uploadedFile from "../../../Assets/images/home/ai-banner-img/upload-img.webp";
import Genrative from "../../../Assets/images/home/ai-banner-img/generative-by-ai.webp";
import hearUgo from "../../../Assets/images/home/ai-banner-img/here-u-go.webp";
import Slider from "react-slick";
import { Col, Container, Image, Row } from "react-bootstrap";

const HowItWorksData = [
    {
        icon: uploadedFile,
        title: "Upload Image",
        description: "Upload your product image and write the name of the product, that’s all it takes to get going.",
    },
    {
        icon: Genrative,
        title: "Click on “Generative by AI”",
        description: "Click on “Generative by AI” and let it carve the content for you. ",
    },
    {
        icon: hearUgo,
        title: "Here You Go!",
        description: "Your unique SEO- friendly product description is ready.",
    },
];
const settingsHowItWorks = {
    dots: false,
    infinite: true,
    autoplay: true,
    arrows:false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
         {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

const HowItWorks = () => {
    return (
        <section className="ai_how_it_works_section">
            <Container className="bw_custome_footer_container ">
                <Row>
                    <Col>
                        <h2 className="Power_AI_headings">
                          How It Works
                        </h2>
                    </Col>
                </Row>
                {/* <Row>
                    <Col sm={12} md={7} lg={7}>
                        <div className="gif_gif_section_left">
                            <Image src={smartProducts} alt="smartProducts" className="img-fluid" />
                        </div>
                    </Col>
                    <Col sm={12} md={5} lg={5} className="d-flex align-items-center">
                        <div className="gif_text_section_right">
                            <h3>Smarter Product Tittle &
                                Descriptions in Seconds</h3>
                            <p>Create professional product photos with our
                                AI-enabled image editing tool. Instantly generate,
                                match, or remove the background of your existing
                                product images using just a few clicks or keywords.</p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    
                    <Col sm={12} md={5} lg={5} className="d-flex align-items-center">
                        <div className="gif_text_section_right">
                            <h3>Generate SEO-Optimized
Meta Titles, Descriptions and
Keywords with Ai</h3>
                            <p>Boost your website’s visibility on search engines
with AI-powered meta content generation. Instantly
create relevant and optimized meta titles, keywords,
and descriptions.</p>
                        </div>
                    </Col>
                    <Col sm={12} md={7} lg={7}>
                        <div className="gif_gif_section_left">
                            <Image src={Genrative} alt="smartProducts" className="img-fluid" />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={7} lg={7}>
                        <div className="gif_gif_section_left">
                            <Image src={CreateImg} alt="smartProducts" className="img-fluid" />
                        </div>
                    </Col>
                    <Col sm={12} md={5} lg={5} className="d-flex align-items-center">
                        <div className="gif_text_section_right">
                            <h3>Create Stunning
Images Instantly.</h3>
                            <p>Generate high-quality images from text prompts
using our AI-powered tool—perfect for designers,
marketers, and creatives.</p>
                        </div>
                    </Col>
                </Row> */}
          

                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <Slider {...settingsHowItWorks} className="powered_ai_seo_slider">
                            {HowItWorksData.map((feature, index) => (
                                <div className="powered_ai_seo_slider_outer">
 <div key={index} className="flex flex-col items-center text-center powered_ai_seo_slider_inner">
                                    <div className="text-center">
                                        <img src={feature.icon} alt={feature.title} className="w-8 h-8" />
                                    </div>
                                    <h3 className="font-semibold mb-2">{feature.title}</h3>
                                    <p className="text-gray-600 text-sm text-center max-w-xs">
                                        {feature.description}
                                    </p>
                                </div>
                                </div>
                               
                            ))}

                        </Slider>
                    </Col>
                </Row>
            </Container>

        </section>
    );
};

export default HowItWorks;